import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link, Redirect, withRouter } from "react-router-dom";

import axios from "axios";
import { debounce } from 'lodash';

import Navbar from '../../EndUser/EU-Navbar.jsx';
import EUSidebar from '../../EndUser/EUSidebar';
import ModalRoutes from '../ModalRoutes.jsx';

import { EUVehicleCard } from '../../EndUser/EUVehicleCard';
import EUBookingPullout from '../../EndUser/EUBookingPullout.jsx';
import EUOEMBanner from '../../EndUser/EUOEMBanner';
import EUDateFilter from '../../EndUser/Filters/EUDateFilter';
import { LoadingIcon } from '../../Common/Loading_Icon';

import { checkCredentials } from '../../../Helpers/checkCredentials';
import { setVehicleDb } from '../../../Actions/endUserActions';
import { Phone, Mail } from '../../Common/Buttons/Icons.js';
import { formatPhone } from '../../../Helpers/PhoneHelper.js';
import { Translation, Trans } from 'react-i18next';


class EUOEM extends Component {

    constructor(props) {
        super(props);

        this.searchVehicles = debounce(this.searchVehicles, 500);
        this.clearSearch = this.clearSearch.bind(this);
        this.updateFilters = this.updateFilters.bind(this);
        this.updateVehicles = this.updateVehicles.bind(this);
        this.updateDate = this.updateDate.bind(this);
        this.clearDates = this.clearDates.bind(this);

        this.state = { 
            loading: true,
            searching: false,
            current_search: "",
            start_date: "",
            end_date: "",
            banner: [],
            vehicles: [],
            contacts: [],
        };
    }

    componentDidMount() {
        document.title = "OEM - FleetXPress"
        var self = this;

        if(this.props.match.params.stakeholder != undefined && this.props.match.params.division != undefined)
        {
            axios.get('/ajax/eu-oem/' + this.props.match.params.stakeholder + '/' + this.props.match.params.division)
            .then(function(response) {
                checkCredentials(response);

                if (response?.data.redirect) {
                    showStatusMsg("Something went wrong, if you already asked for access to this fleet please try to log out and log in again. If you still have problems please contact us.");

                    self.props.history.push(('/' + response?.data.redirect));
                    window.location.reload();

                    return;
                }

                if (!response?.data.status && response?.data.vehicles) {
                    self.props.dispatch(setVehicleDb(response?.data.vehicles, self.props.endUser.vehicle_db))

                    self.setState({
                        loading: false,
                        banner: response?.data.banner,
                        vehicles: response?.data.vehicles,
                        contacts: response?.data.vmhsh[0].contacts
                    })
                }
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    toggleSidebar() {
        const sidebar = document.getElementById('eu-sidebar');
        const openBtn = document.getElementById('open-sidebar-btn');
        if (!sidebar || !openBtn) return;

        sidebar.classList.toggle("is-active");
        openBtn.classList.toggle("is-active");

        if(openBtn.innerHTML === '<i class="fas fa-chevron-right"></i>') {
            openBtn.innerHTML = '<i class="fas fa-chevron-left"></i>';
        } else {
            openBtn.innerHTML = '<i class="fas fa-chevron-right"></i>';
        }
    }

    searchVehicles(e) {
        var search = document.getElementById('searchbar').value

        this.setState({
            searching: true,
            current_search: search
        });

        this.updateVehicles();
    }

    clearSearch(e) {
        document.getElementById("searchbar").value = ""

        this.state.current_search = "";

        this.updateVehicles();
    }

    updateVehicles() {
        var self = this;

        axios.post('/ajax/eu-home/update', {
            search_term: this.state.current_search,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            stakeholder: this.props.match.params.stakeholder,
            division: this.props.match.params.division
        }).then(function(response) {
            checkCredentials(response);
            self.props.dispatch(setVehicleDb(response?.data.vehicles, self.props.endUser.vehicle_db))
            self.setState({
                searching: false,
                vehicles: response?.data.vehicles
            })
        }).catch(function(error) {
            self.setState({
                searching: false
            })
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    updateDate(date, field) {
        if(field == "start_date") {
            this.setState({
                start_date: date,
            });
        } else if(field == "end_date") {
            this.setState({
                end_date: date,
            });
        }

        this.updateFilters();
        this.updateVehicles();
    }

    updateFilters() {
        if($('#vehicle-start-date').val() != "" || $('#vehicle-end-date').val() != "") {
            $("#dates-dropdown-button").addClass('filter-is-active');
        } else {
            $("#dates-dropdown-button").removeClass('filter-is-active');
        }
    }

    clearDates() {
        this.state.start_date = "";
        this.state.end_date = "";

        this.updateFilters();
        this.updateVehicles();
    }

    render() {        
        return (
            <div>
                <Navbar history={this.props.history} match={this.props.match} location={this.props.location} />
                <div className="container flex eu-container">
                    {/* <div className="open-sidebar-btn" id = "open-sidebar-btn" onClick = {this.toggleSidebar}>
                        <i className="fas fa-chevron-right"></i>
                    </div> */}

                    {/*Sidebar Section*/}
                    <EUSidebar match={this.props.match} history={this.props.history} location={this.props.location}/>
                    
                    {/*Main Section*/}
                    {
                        ! this.state.loading ? 
                            <div className="eu-mainsection">
                                <div className="eu-oem-mainsection">
                                    {/* Banner & Blurb */}
                                    <EUOEMBanner history={this.props.history} match={this.props.match} loading={this.state.loading} banner={this.state.banner} />

                                    {/* Vehicles */}
                                    <div className="eu-oem-mainsection-vehicles-search">
                                        <div className = "search-field-container">
                                            <Translation>
                                                {
                                                    (t, {i18n}) => <input className="search-input-field no-margin" type="text" placeholder={t("Search Vehicles")} id="searchbar" onChange={(e) => {this.searchVehicles(e)}}/>
                                                }
                                            </Translation>
                                            {/*Show when searching*/}
                                            {
                                                this.state.searching ?
                                                    <div className="loading-wrapper">
                                                        <div className="lds-ring bkg-border-primary"><div></div><div></div><div></div><div></div></div>
                                                    </div>
                                                :
                                                    null
                                            }

                                            {/*Show when input field has text*/}
                                            {
                                                this.state.current_search.length && !this.state.searching ?
                                                    <a className = "close-icon" onClick={this.clearSearch}>
                                                        <img src = "images/png-icons/close-grey.png"/>
                                                    </a> 
                                                :
                                                    null
                                            }
                                        </div>
                                        <div className = "dates-field-container">
                                            <EUDateFilter name="date" onChange={this.updateDate} clearDates={this.clearDates} type_name="date" />
                                        </div>
                                    </div>
                                    <div className="eu-oem-mainsection-vehicles-section">
                                        {
                                            this.props.endUser.vehicles.length > 0 ?
                                                this.props.endUser.vehicles.map((vehicle) => {
                                                    return(
                                                        <EUVehicleCard settings={this.props.settings} vehicle={vehicle} />
                                                    )
                                                })
                                            :
                                                <div className = "emptystate-wrapper">
                                                    <h2><Trans>No Vehicles Found</Trans></h2>
                                                    <img style={{width: "100px"}} src = "images/emptystate-icons/Vehicle_Inactive.svg"/>
                                                    <p><Trans>Try adjusting your search or dates</Trans>.</p>
                                                </div>
                                        }
                                    </div>
                                </div>
                                <div className="eu-oem-contactsection">
                                    <h2><Trans>Contact Us</Trans></h2>
                                    {
                                        this.state.contacts.slice(0, 3).map((contact) => {
                                            var profile = contact.profile
                                            var image = 'images/profile-contact-image.png'
                                            if (profile.photo) {
                                                image = "https://digitalvms.s3.ca-central-1.amazonaws.com/profile-images/" + profile.photo.Link;
                                            }

                                            return(
                                                <div className="eu-oem-contact--card">
                                                <div className="eu-oem--contact-img" style = {{backgroundImage:`url(${image})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain'}}>
                
                                                </div>
                                                <div className="eu-oem--contact-desc">
                                                    <h3 className = "eu-oem--contact-desc-name">{profile.First_Name} {profile.Last_Name}</h3>
                                                    <a href={`mailto: ${profile.Email}`}><span style={{margin:'2px 7px 0 0'}}>{Mail()}</span>{profile.Email}</a>
                                                    {
                                                        profile.phonenumbers && profile.phonenumbers.length > 0 ?
                                                            <a href={`tel: ${profile.phonenumbers[0].Number}`}><span style={{margin:'2px 7px 0 0'}}>{Phone()}</span>{formatPhone(profile.phonenumbers[0].Number)}</a>
                                                        :
                                                            null
                                                    }
                                                    
                                                </div>
                                            </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                    :
                        <LoadingIcon />
                    }
                    
                </div>
                <ModalRoutes match={this.props.match} history={this.props.history} location={this.props.location}/>
                <EUBookingPullout history={this.props.history} match={this.props.match} location={this.props.location}/>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    endUser: store.endUser,
    settings: store.settings
})

export default connect(mapStateToProps)(EUOEM)